module.exports = __webpack_public_path__ + "static/img/apk.a37e614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/apk.png
// module id = 5SIh
// module chunks = 53